import {
  addDays,
  differenceInCalendarDays,
  format,
  parseISO,
  startOfDay,
} from 'date-fns'
import { es } from 'date-fns/locale'

export const HOY = startOfDay(new Date())

/** Genera una fecha ISO relativa a hoy, para que el prototipo siempre esté vigente. */
export function fechaRel(dias: number): string {
  return format(addDays(HOY, dias), 'yyyy-MM-dd')
}

export function diasRestantes(iso: string): number {
  return differenceInCalendarDays(parseISO(iso), HOY)
}

export function fechaCorta(iso: string): string {
  return format(parseISO(iso), "dd 'de' LLL yyyy", { locale: es })
}

export function fechaLarga(iso: string): string {
  return format(parseISO(iso), "EEEE dd 'de' LLLL yyyy", { locale: es })
}

export function diaMes(iso: string): string {
  return format(parseISO(iso), 'dd LLL', { locale: es })
}

export function etiquetaDias(dias: number): string {
  if (dias < 0) return `Vencido hace ${Math.abs(dias)} d`
  if (dias === 0) return 'Vence hoy'
  if (dias === 1) return 'Mañana'
  return `En ${dias} días`
}

export function capitalizar(texto: string): string {
  return texto.charAt(0).toUpperCase() + texto.slice(1)
}
